/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Users_Invite_Confirm_CtaInputs */

const cs_users_invite_confirm_cta = /** @type {(inputs: Users_Invite_Confirm_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odeslat pozvánky`)
};

const en_users_invite_confirm_cta = /** @type {(inputs: Users_Invite_Confirm_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Send invitations`)
};

/**
* | output |
* | --- |
* | "Send invitations" |
*
* @param {Users_Invite_Confirm_CtaInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const users_invite_confirm_cta = /** @type {((inputs?: Users_Invite_Confirm_CtaInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Users_Invite_Confirm_CtaInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_users_invite_confirm_cta(inputs)
	return cs_users_invite_confirm_cta(inputs)
});